import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_n9fwmzzqs5: FaireBrandEntity = {
  token: "b_n9fwmzzqs5",
  type: "brand",
  name: "One Nine",
  avatarUrl:
    "https://cdn.faire.com/fastly/8f0740ad1550c0028621502f8e488ce2b54245d714de0626858fd3a1e565c37b.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/be4cccc12c5c7161333d00f64d9415d9e53a352887f95dc5aeba79f9a9604943.png",
  logoUrl:
    "https://cdn.faire.com/fastly/8f0740ad1550c0028621502f8e488ce2b54245d714de0626858fd3a1e565c37b.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/be4cccc12c5c7161333d00f64d9415d9e53a352887f95dc5aeba79f9a9604943.png",
  location: "Houston, TX, USA",
  minimumOrderDollars: 150,
  rating: 4.8,
  reviewCount: 82,
  isTopShop: true,
  isInsider: true,
  description:
    'At Shop "One Nine," we\'re more than just a custom embroidery and printing business. \nAs a family-run company, we bring a personal touch to every project, ensuring each product is crafted with the same care as if it were for our own family. \nWe partner with you to create a wide variety of products, turning your unique ideas into reality, no matter the size of the order.\n\nWhy Choose Shop "One Nine"?\nPersonalized Service with a Family Touch: \nWe build strong, personal relationships, treating every client like family and understanding your specific needs and preferences.\n\nVersatility and Creativity: \nFrom custom apparel to promotional items and bespoke gifts, we embrace new challenges and bring your ideas to life with creativity and precision.\n\nQuality Craftsmanship: \nUsing state-of-the-art embroidery and printing technology, we ensure each product meets our high standards of excellence.\n\nSmall Batch Friendly: \n\nWhether you need a single piece or a small batch, we give every project our full attention and expertise.\n\nCollaborative Growth :\n We foster open communication and collaboration, creating a supportive community where both our business and yours can thrive.\n\nLet\'s Grow Together\n\nAt Shop "One Nine," we believe in the power of partnership and communication. As a family business, we are dedicated to building lasting relationships and supporting each other’s growth. Together, we can create something special.\n\n\n',
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:46:15.339Z",
    importedBy: "entity-db-cli",
  },
};
